class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

handleIntersection(entries, observer) {
  //只有第一次初始化获取数据
  if (!entries[0].isIntersecting) return;
  observer.unobserve(this);

  // 发送请求获取 mini-cart 和 bundle-cart 的内容
  const miniCartFetch = fetch(this.dataset.url).then(response => response.text());
  const bundleCart = document.getElementById('bundle-cart');

  let bundleCartFetch;
  if (bundleCart) {
    bundleCartFetch = fetch(bundleCart.dataset.url).then(response => response.text());
  } else {
    bundleCartFetch = Promise.resolve(); // 如果没有 bundle-cart，返回一个 resolved 的 Promise
  }

  Promise.all([miniCartFetch, bundleCartFetch])
    .then(([miniCartHtml, bundleHtml]) => {
      document.getElementById('mini-cart').innerHTML =
        this.getSectionInnerHTML(miniCartHtml, '.shopify-section');
      if (bundleHtml) {
        bundleCart.innerHTML = this.getSectionInnerHTML(bundleHtml, '.shopify-section');
      }

      //---data-track start 标记 cart-drawer 内容已加载
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) cartDrawer.cartContentLoaded = true;
      //---data-track end
      
      document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
    })
    .catch(e => {
      console.error(e);
    });
}


  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  //渲染正常的单一产品
  renderContents(parsedState) {

    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {

        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  //渲染bundle产品
  renderBundleContent(parsedState){

    this.getBundleSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {

        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {

    let sections = [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id:"bundle-cart",
        section:"bundle-cart",
        selector: '.shopify-section'
      }
    ];

    if (document.querySelector('#mini-cart__header_id .free-gift-progress')) {
      sections.push({
        id: 'cart-free-gift-progress',
        section: 'cart-free-gift-progress',
        selector: '.shopify-section',
      });
    }

    return sections;
    
    // return [
    //   {
    //     id: 'mini-cart',
    //     section: 'mini-cart',
    //     selector: '.shopify-section'
    //   },
    //   {
    //     id: 'cart-icon-bubble',
    //     section: 'cart-icon-bubble',
    //     selector: '.shopify-section'
    //   },
    //   {
    //     id: 'mobile-cart-icon-bubble',
    //     section: 'mobile-cart-icon-bubble',
    //     selector: '.shopify-section'
    //   },
    //   {
    //     id:"bundle-cart",
    //     section:"bundle-cart",
    //     selector: '.shopify-section'
    //   }
    // ];
  }

  getBundleSectionsToRender() {
    return [
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id:"bundle-cart",
        section:"bundle-cart",
        selector: '.shopify-section'
      }
    ];
  }
  
  
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);
